import React, { useEffect, useState } from 'react';

type Req = (path: string, body?: any, signal?: AbortSignal) => Promise<any>;
const PATH = '/api/rolling/simple-bsp/brain-to-ashleigh';

// Owner switch: push every Brain Daily 3 pick to Ashleigh's bot at her own default Brain stake.
const BrainToAshleighToggle: React.FC<{ request: Req }> = ({ request }) => {
  const [d, setD] = useState<{ enabled: boolean; stake: number | null } | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    const ac = new AbortController();
    request(PATH, undefined, ac.signal).then(setD).catch((e: any) => { if (!ac.signal.aborted) setError(e.message); });
    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function flip() {
    if (!d) return;
    const next = !d.enabled;
    setBusy(true); setError('');
    try { setD(await request(PATH, { enabled: next })); } catch (e: any) { setError(e.message); } finally { setBusy(false); }
  }
  const stake = d?.stake ? '$' + d.stake : 'her default stake';
  return (
    <div className="fady-mirror-toggle" role="group" aria-label="Push Brain picks to Ashleigh">
      <strong>Brain picks to Ashleigh</strong>
      <span className={'fady-mirror-state ' + (d?.enabled ? 'on' : 'off')}>{d === null ? '...' : d.enabled ? `ON - at ${stake}` : 'OFF'}</span>
      <button type="button" disabled={busy || d === null} onClick={flip}
        style={d?.enabled ? undefined : { background: '#15803d', color: '#fff', borderColor: '#15803d' }}>
        {d?.enabled ? 'Stop pushing to Ashleigh' : 'Push to Ashleigh'}</button>
      <small>On: every Brain Daily 3 pick is also bet on Ashleigh's account at T-5, at her default Brain stake ({stake}), from her own Betfair balance. Her Fady copies are unaffected.</small>
      {error && <span role="alert">{error}</span>}
    </div>
  );
};
export default BrainToAshleighToggle;
